<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<div class="container-fluid h-100">
  <br><br><br><br><br>
  <!-- Google tag (gtag.js) -->
  <!--
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-LWQRV5QS22"></script>
  <script> window.dataLayer = window.dataLayer || [];  function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-LWQRV5QS22'); </script>
-->
  <div class="row h-100">
    <div class="col section-content">
      <div class="content-container">
        <div class="icon-circle">
          <i class="bi bi-box-arrow-in-left">
          </i>
        </div>
        <app-st-header-title [inputVal]="'Payment Canceled'"></app-st-header-title>
        <app-st-span [inputVal]="'Click here if you are not directed.'"></app-st-span>
        <br>
        <br>
        <app-st-button [label]="'Your Dashboard'" [primary]="true" (onClick)="onGoToDashboard()"></app-st-button>
      </div>
    </div>
  </div>
</div>


